import { cloneDeep } from 'lodash';

const SET_LAST_ORDER_CART = 'SET_LAST_ORDER_CART';
const SET_LAST_ORDER_CART_FALSE = 'SET_LAST_ORDER_CART_FALSE';

const initialStateLastOrderCart = false;

export default function reducer(state = cloneDeep(initialStateLastOrderCart), action) {
	switch (action.type) {
		case SET_LAST_ORDER_CART:
			return action.payload;
		case SET_LAST_ORDER_CART_FALSE:
			return false;
		default:
			return state;
	}
}

export function setLastOrderCart( obj ){
  return {
    type: SET_LAST_ORDER_CART,
    payload: obj
  }
}

export function clearLastOrderCart(){
  return { type: SET_LAST_ORDER_CART_FALSE }
}


// WEBPACK FOOTER //
// ./src/modules/last_order_cart.js